document.addEventListener('DOMContentLoaded', () => {
  const details = document.getElementById('Details-HeaderMenu-1');
  const summary = details.querySelector('summary');

  /* summary（メニュー項目）をhoverでトグル */
  summary.addEventListener('mouseenter', () => {
    if (details.open) {
      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
    } else {
      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
    }
  });

  /* 外クリックで閉じる */
  document.addEventListener('click', (e) => {
    if (!details.contains(e.target)) {
      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
    }
  });

  /* Enter / Space でトグル（a11y対応） */
  summary.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      details.open = !details.open;
      summary.setAttribute('aria-expanded', String(details.open));
    }
  });
});
